export default class CommunicationModal extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        var modal = new bootstrap.Modal(this);
        var key = 'modal-communication-' + $(this).data('cookie-key');
        var value = localStorage.getItem(key);

        if (!value || new Date().getTime() > value) {
            modal.show();
            localStorage.setItem(key, new Date().getTime() + (1 * 60 * 60 * 1000)); // Affichage toutes les heures | Temps en millisecondes depuis 1/1/1970
        }
    }

}